import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClienteClase } from 'src/app/models/ClienteClase.model';
import { ClienteService } from 'src/app/services/cliente.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { basicAlert } from '../../utils';

@Component({
  selector: 'app-md-ic-clase-edt',
  templateUrl: './md-ic-clase-edt.component.html',
  styleUrls: ['./md-ic-clase-edt.component.css']
})
export class MdIcClaseEdtComponent implements OnInit {

  listaclases = [];
  listacodigos = [];

  ClaseTemp = new ClienteClase()


  public codClase: number;
  public desClase: string;
  public codCodigoClase: number;
  public desCodigoClase: string;

  disabledCodigosClaseCombo: boolean = true;


  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private clienteService: ClienteService,
  ) { }

  ngOnInit(): void {
    this.clienteService.buscarClases().subscribe(response => {
      this.listaclases = response.body;
      this.codClase = this.listaclases[0].codigo
      this.onChangeClases(this.codClase)
    })
  }

  _close() {
    this.modalactiveService.dismiss('canceling');
  }

  _ok() {


    if (this.codClase != null && this.codCodigoClase != null) {

      this.ClaseTemp = new ClienteClase();
      this.ClaseTemp.clase = this.codClase;
      this.listaclases.forEach(element => {
        if (element.codigo == this.codClase) {
          this.desClase = element.descri;
        }
      });
      this.ClaseTemp.desclase = this.desClase;

      //obteniendo la descripcion del codigo en desCodigoClase
      this.listacodigos.forEach(element => {
        if (element.codigo == this.codCodigoClase) {
          this.desCodigoClase = element.descri;
        }
      });

      //this.ClaseTemp.codmot =this.inputclase;
      this.ClaseTemp.codigo = this.codCodigoClase;
      this.ClaseTemp.descodigo = this.desCodigoClase;

      this.modalactiveService.close(this.ClaseTemp);

    } else {
      //En caso no se llenen los datos necesarios
      var dato = ''
      if (this.codClase == null) {
        dato = '"Clase"'
      } else if (this.codCodigoClase == null) {
        dato = '"Código"'
      }
      basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');

    }

  }

  onChangeClases(clase: any) {
    this.spinnerService.activarLoading(true)
    this.disabledCodigosClaseCombo = false;
    this.listacodigos = [];
    this.codCodigoClase = null;
    this.obtenerListaClasesCodigos(clase);
  }

  obtenerListaClasesCodigos(clase: any) {
    this.clienteService.buscarCodigos(clase).subscribe(response => {
      this.listacodigos = response.body;
      this.codCodigoClase = this.listacodigos[0].codigo
      this.spinnerService.activarLoading(false)
    })
  }


}
